// Formulaire SITC

function slugify(text) {
  text = text.toString().toLowerCase().trim();

  const sets = [
    { to: "a", from: "[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]" },
    { to: "c", from: "[ÇĆĈČ]" },
    { to: "d", from: "[ÐĎĐÞ]" },
    { to: "e", from: "[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]" },
    { to: "g", from: "[ĜĞĢǴ]" },
    { to: "h", from: "[ĤḦ]" },
    { to: "i", from: "[ÌÍÎÏĨĪĮİỈỊ]" },
    { to: "j", from: "[Ĵ]" },
    { to: "ij", from: "[Ĳ]" },
    { to: "k", from: "[Ķ]" },
    { to: "l", from: "[ĹĻĽŁ]" },
    { to: "m", from: "[Ḿ]" },
    { to: "n", from: "[ÑŃŅŇ]" },
    { to: "o", from: "[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]" },
    { to: "oe", from: "[Œ]" },
    { to: "p", from: "[ṕ]" },
    { to: "r", from: "[ŔŖŘ]" },
    { to: "s", from: "[ßŚŜŞŠȘ]" },
    { to: "t", from: "[ŢŤ]" },
    { to: "u", from: "[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]" },
    { to: "w", from: "[ẂŴẀẄ]" },
    { to: "x", from: "[ẍ]" },
    { to: "y", from: "[ÝŶŸỲỴỶỸ]" },
    { to: "z", from: "[ŹŻŽ]" },
    { to: "-", from: "[·/_,:;']" },
  ];

  sets.forEach((set) => {
    text = text.replace(new RegExp(set.from, "gi"), set.to);
  });

  return text
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^-a-z0-9а-я\u0370-\u03ff\u1f00-\u1fff]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

// --- Dates -------------------------------------------------------------
//
// Trois blocs alternatifs : dates fixes, période, récurrence.
// Les champs visibles ne portent aucun "name" : seuls les champs cachés
// (data-name) transportent la valeur normalisée "YYYY-MM-DDTHH:mm:ss", et leur
// "name" n'est posé qu'à l'envoi, uniquement s'ils contiennent une date valide.
// Sans cela le formulaire postait à chaque envoi des dates vides ou tronquées
// (du type "T11:00:00"), que l'application convertissait en date aberrante.

const SITC_DATETIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const SITC_TZ = "Europe/Luxembourg";

// Décalage d'Europe/Luxembourg (en minutes) pour un instant donné.
function sitcZoneOffsetMinutes(instant) {
  try {
    const parts = {};
    new Intl.DateTimeFormat("en-US", {
      timeZone: SITC_TZ,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
      .formatToParts(instant)
      .forEach((part) => (parts[part.type] = part.value));
    const asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
    return Math.round((asUTC - instant.getTime()) / 60000);
  } catch (err) {
    return null;
  }
}

// Suffixe de fuseau ("+02:00" en été, "+01:00" en hiver) correspondant à une
// heure locale luxembourgeoise. Une date envoyée sans fuseau est comprise comme
// de l'UTC par l'application : l'heure de début d'une récurrence se retrouvait
// décalée (12:00 saisi, 14:00 enregistré en heure d'été). Le fuseau est celui du
// Luxembourg, jamais celui du navigateur : un demandeur à l'étranger enverrait
// sinon son heure locale.
function sitcOffsetSuffix(value) {
  if (!SITC_DATETIME_RE.test(value)) return "";
  const [datePart, timePart] = value.split("T");
  const [y, m, d] = datePart.split("-").map(Number);
  const [hh, mm, ss] = timePart.split(":").map(Number);
  const naive = Date.UTC(y, m - 1, d, hh, mm, ss);
  // première passe : offset supposé, deuxième : offset de l'instant réel
  let offset = sitcZoneOffsetMinutes(new Date(naive));
  if (offset === null) return "";
  offset = sitcZoneOffsetMinutes(new Date(naive - offset * 60000));
  if (offset === null) return "";
  const abs = Math.abs(offset);
  const pad = (n) => (n < 10 ? "0" + n : "" + n);
  return (offset < 0 ? "-" : "+") + pad(Math.floor(abs / 60)) + ":" + pad(abs % 60);
}

function sitcCombine(dateValue, hourValue) {
  if (!dateValue) return "";
  return dateValue + "T" + (hourValue || "00:00") + ":00";
}

function sitcSyncFixedRow(row) {
  if (!row) return;
  const date = row.querySelector(".js-date-from");
  const hourFrom = row.querySelector(".js-hour-from");
  const hourTo = row.querySelector(".js-hour-to");
  const from = row.querySelector(".js-date-from-timezone");
  const to = row.querySelector(".js-date-to-timezone");
  if (!date || !from || !to) return;
  from.value = sitcCombine(date.value, hourFrom ? hourFrom.value : "");
  // sans heure de fin, la date de fin vaut la date de début : sinon un événement
  // à 18:00 se terminait à 00:00 le même jour, donc avant d'avoir commencé.
  to.value = hourTo && hourTo.value ? sitcCombine(date.value, hourTo.value) : from.value;
}

function sitcSyncPeriod() {
  const row = document.querySelector(".js-date-wrapper-period");
  if (!row) return;
  const dateFrom = row.querySelector(".js-period-date-from");
  const dateTo = row.querySelector(".js-period-date-to");
  const hourFrom = row.querySelector(".js-period-hour-from");
  const hourTo = row.querySelector(".js-period-hour-to");
  row.querySelector(".js-period-from-timezone").value = sitcCombine(dateFrom.value, hourFrom.value);
  row.querySelector(".js-period-to-timezone").value = sitcCombine(dateTo.value, hourTo.value);
}

function sitcSyncRecurrence() {
  const row = document.querySelector(".js-date-wrapper-recurrence");
  if (!row) return;
  const dateFrom = row.querySelector(".js-daterec-from");
  const dateTo = row.querySelector(".js-daterec-to");
  const hourFrom = row.querySelector(".js-hourrec-from");
  const hourTo = row.querySelector(".js-hourrec-to");
  document.querySelector(".js-daterec-from-timezone").value = sitcCombine(dateFrom.value, hourFrom.value);
  document.querySelector(".js-daterec-to-timezone").value = sitcCombine(dateTo.value, hourTo.value);
}

function sitcSyncAllDates() {
  document.querySelectorAll(".js-date-fixed").forEach(sitcSyncFixedRow);
  sitcSyncPeriod();
  sitcSyncRecurrence();
}

// Photographie de l'état des trois blocs, utilisée par la validation et par la
// pose des "name" au moment de l'envoi.
function sitcReadDateBlocks() {
  const fixedRows = [...document.querySelectorAll(".js-date-fixed")];
  const fixed = [];
  const fixedIncomplete = [];
  fixedRows.forEach((row) => {
    const date = row.querySelector(".js-date-from");
    const hourFrom = row.querySelector(".js-hour-from");
    const hourTo = row.querySelector(".js-hour-to");
    const hasHour = (hourFrom && hourFrom.value) || (hourTo && hourTo.value);
    if (date && date.value) fixed.push(row);
    else if (hasHour) fixedIncomplete.push(row);
  });

  const periodRow = document.querySelector(".js-date-wrapper-period");
  const periodFrom = periodRow ? periodRow.querySelector(".js-period-date-from") : null;
  const periodTo = periodRow ? periodRow.querySelector(".js-period-date-to") : null;
  const period = {
    row: periodRow,
    fromField: periodFrom,
    toField: periodTo,
    hasFrom: !!(periodFrom && periodFrom.value),
    hasTo: !!(periodTo && periodTo.value),
  };
  period.used = period.hasFrom || period.hasTo;
  period.complete = period.hasFrom && period.hasTo;

  const recRow = document.querySelector(".js-date-wrapper-recurrence");
  const recFrom = recRow ? recRow.querySelector(".js-daterec-from") : null;
  const recTo = recRow ? recRow.querySelector(".js-daterec-to") : null;
  const recurrence = {
    row: recRow,
    fromField: recFrom,
    toField: recTo,
    hasFrom: !!(recFrom && recFrom.value),
    hasTo: !!(recTo && recTo.value),
  };
  recurrence.used = recurrence.hasFrom || recurrence.hasTo;
  recurrence.complete = recurrence.hasFrom && recurrence.hasTo;

  return { fixed, fixedIncomplete, period, recurrence };
}

// Pose les "name" juste avant l'envoi : rien de vide, rien de malformé ne part.
function sitcApplyDateNames(form) {
  form.querySelectorAll("[data-name]").forEach((el) => el.removeAttribute("name"));

  const blocks = sitcReadDateBlocks();
  let index = 0;

  blocks.fixed.forEach((row) => {
    const from = row.querySelector(".js-date-from-timezone");
    const to = row.querySelector(".js-date-to-timezone");
    if (!SITC_DATETIME_RE.test(from.value) || !SITC_DATETIME_RE.test(to.value)) return;
    from.setAttribute("name", "event.dates[" + index + "].from");
    to.setAttribute("name", "event.dates[" + index + "].to");
    index += 1;
  });

  if (blocks.period.complete) {
    const from = document.querySelector(".js-period-from-timezone");
    const to = document.querySelector(".js-period-to-timezone");
    if (SITC_DATETIME_RE.test(from.value) && SITC_DATETIME_RE.test(to.value)) {
      from.setAttribute("name", "event.dates[" + index + "].from");
      to.setAttribute("name", "event.dates[" + index + "].to");
    }
  }

  if (blocks.recurrence.complete) {
    const from = document.querySelector(".js-daterec-from-timezone");
    const to = document.querySelector(".js-daterec-to-timezone");
    if (SITC_DATETIME_RE.test(from.value) && SITC_DATETIME_RE.test(to.value)) {
      // fuseau explicite : sans lui, l'application lit l'heure de début comme de l'UTC
      from.value += sitcOffsetSuffix(from.value);
      to.value += sitcOffsetSuffix(to.value);
      from.setAttribute("name", from.dataset.name);
      to.setAttribute("name", to.dataset.name);
      // les jours ne sont transmis qu'avec une récurrence réellement renseignée
      document.querySelectorAll(".js-rec-day").forEach((day) => day.setAttribute("name", day.dataset.name));
    }
  }
}

// --- Validation côté navigateur ----------------------------------------
//
// Le formulaire est en novalidate (les messages natifs ne sont ni traduits ni
// utilisables pour les champs cachés des éditeurs Quill) : on fait la
// vérification ici, avant tout aller-retour serveur.
// Les libellés viennent des attributs data-msg-* du <form>, donc traduits.

const SITC_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

function sitcRelabelFixedRow(row, index) {
  const number = index + 1;
  const dateLabel = row.querySelector(".js-dateFrom-label");
  const hourFromLabel = row.querySelector(".js-hour-from-label");
  const hourToLabel = row.querySelector(".js-hour-to-label");
  if (dateLabel) {
    dateLabel.setAttribute("for", "dateFrom" + index);
    dateLabel.textContent = dateLabel.textContent.replace(/\s*\d+\s*$/, "") + " " + number;
  }
  if (hourFromLabel) {
    hourFromLabel.setAttribute("for", "hourFrom" + index);
    hourFromLabel.textContent = hourFromLabel.textContent.replace(/\s*\d+\s*$/, "") + " " + number;
  }
  if (hourToLabel) {
    hourToLabel.setAttribute("for", "hourTo" + index);
    hourToLabel.textContent = hourToLabel.textContent.replace(/\s*\d+\s*$/, "") + " " + number;
  }
}

// Élément après lequel afficher le message, et élément à marquer/focaliser.
function sitcFocusTarget(field) {
  if (field.type === "hidden" && field.id && field.id.indexOf("hidden-desc") === 0) {
    const editor = document.getElementById(field.id.replace("hidden-desc", "editor"));
    return editor ? editor.querySelector(".ql-editor") || editor : field;
  }
  return field;
}

function sitcErrorAnchor(field) {
  const target = sitcFocusTarget(field);
  if (target !== field) return target.closest(".editor-wysiwyg") || target.parentNode;
  // la case RGPD est dans une ligne flex avec son libellé : le message doit
  // sortir de cette ligne, pas s'intercaler entre la case et le texte.
  if (field.type === "checkbox") return field.closest(".flex") || field;
  return target;
}

function sitcClearErrors(form) {
  form.querySelectorAll(".js-field-error").forEach((el) => el.remove());
  form.querySelectorAll("[aria-invalid]").forEach((el) => {
    el.removeAttribute("aria-invalid");
    el.removeAttribute("aria-describedby");
    el.classList.remove("border-red-500", "!border-red-500");
  });
  const summary = document.getElementById("formSitcSummary");
  if (summary) summary.remove();
  const recaptchaError = document.getElementById("errorRecaptcha");
  if (recaptchaError) recaptchaError.classList.add("hidden");
}

function sitcShowFieldError(field, message) {
  const target = sitcFocusTarget(field);
  const anchor = sitcErrorAnchor(field);
  const id = (field.id || field.name || "sitc-field") + "-error";
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("p");
    el.id = id;
    el.className = "js-field-error text-red-500 text-sm mt-1";
    anchor.insertAdjacentElement("afterend", el);
  }
  el.textContent = message;
  target.setAttribute("aria-invalid", "true");
  target.setAttribute("aria-describedby", id);
  target.classList.add("!border-red-500");
  return target;
}

function sitcValidate(form) {
  const msg = form.dataset;
  const invalid = [];

  sitcClearErrors(form);
  sitcSyncAllDates();

  form.querySelectorAll("input[required], select[required], textarea[required]").forEach((field) => {
    if (field.type === "checkbox") return;
    const value = (field.value || "").trim();
    if (!value) {
      invalid.push(sitcShowFieldError(field, msg.msgRequired));
    } else if (field.type === "email" && !SITC_EMAIL_RE.test(value)) {
      invalid.push(sitcShowFieldError(field, msg.msgEmail));
    }
  });

  // Dates : au moins un bloc, et un seul.
  const blocks = sitcReadDateBlocks();
  const usedBlocks = (blocks.fixed.length > 0 ? 1 : 0) + (blocks.period.used ? 1 : 0) + (blocks.recurrence.used ? 1 : 0);
  const firstFixedDate = document.querySelector(".js-date-fixed .js-date-from");

  if (usedBlocks === 0) {
    if (firstFixedDate) invalid.push(sitcShowFieldError(firstFixedDate, msg.msgDate));
  } else if (usedBlocks > 1) {
    if (firstFixedDate && blocks.fixed.length > 0) invalid.push(sitcShowFieldError(firstFixedDate, msg.msgDateConflict));
    if (blocks.period.used) invalid.push(sitcShowFieldError(blocks.period.fromField, msg.msgDateConflict));
    if (blocks.recurrence.used) invalid.push(sitcShowFieldError(blocks.recurrence.fromField, msg.msgDateConflict));
  } else {
    if (blocks.period.used && !blocks.period.complete) {
      invalid.push(sitcShowFieldError(blocks.period.hasFrom ? blocks.period.toField : blocks.period.fromField, msg.msgDateIncomplete));
    }
    if (blocks.recurrence.used && !blocks.recurrence.complete) {
      invalid.push(sitcShowFieldError(blocks.recurrence.hasFrom ? blocks.recurrence.toField : blocks.recurrence.fromField, msg.msgDateIncomplete));
    }
  }
  // une heure saisie sans sa date ne partirait nulle part : on le signale
  blocks.fixedIncomplete.forEach((row) => {
    invalid.push(sitcShowFieldError(row.querySelector(".js-date-from"), msg.msgDateMissing));
  });

  // Prix : un input number renvoie une chaîne vide quand la saisie n'est pas un
  // nombre (Safari laisse taper "12 €"), ce qui ferait partir le libellé sans
  // son tarif. On le signale au lieu d'envoyer un prix vide.
  form.querySelectorAll("input.js-value-price").forEach((field) => {
    if (field.closest(".js-price-wrapper.hidden")) return;
    const raw = (field.value || "").trim();
    const badInput = field.validity && field.validity.badInput;
    if (badInput || (raw !== "" && !/^\d+(\.\d{1,2})?$/.test(raw))) {
      invalid.push(sitcShowFieldError(field, msg.msgPrice));
    }
  });

  const policy = document.getElementById("checkbox-policy");
  if (policy && !policy.checked) {
    invalid.push(sitcShowFieldError(policy, msg.msgPolicy));
  }

  const recaptchaError = document.getElementById("errorRecaptcha");
  let recaptchaResponse = null;
  try {
    recaptchaResponse = window.grecaptcha ? window.grecaptcha.getResponse() : null;
  } catch (err) {
    recaptchaResponse = null;
  }
  if (recaptchaResponse !== null && recaptchaResponse.length === 0 && recaptchaError) {
    if (!recaptchaError.textContent.trim()) recaptchaError.textContent = msg.msgRecaptcha;
    recaptchaError.classList.remove("hidden");
    invalid.push(document.querySelector(".g-recaptcha"));
  }

  return invalid.filter(Boolean);
}

// Après un POST en erreur la page revient tout en haut : sans ça le bandeau
// d'erreur, situé au niveau du formulaire, passe complètement inaperçu.
document.addEventListener("DOMContentLoaded", function () {
  const serverError = document.getElementById("formSitcServerError");
  if (!serverError) return;
  window.setTimeout(() => {
    serverError.scrollIntoView({ behavior: "smooth", block: "center" });
    serverError.focus({ preventScroll: true });
  }, 150);
});

function sitcShowSummary(form) {
  const summary = document.createElement("div");
  summary.id = "formSitcSummary";
  summary.className = "bg-red-600 text-white text-center p-4 rounded mb-6";
  summary.setAttribute("role", "alert");
  summary.setAttribute("tabindex", "-1");
  summary.textContent = form.dataset.msgSummary;
  form.insertAdjacentElement("afterbegin", summary);
  return summary;
}

if (document.querySelectorAll(".form-sitc").length > 0) {
  console.log("datepicker-sitc", document.querySelectorAll(".datepicker-sitc"));

  flatpickr(".datepicker-sitc", {
    minDate: "today",
    allowInput: true,
    locale: document.querySelector("body").dataset.lang,
  });

  console.log("hourpicker-sitc", document.querySelectorAll(".hourpicker-sitc"));

  flatpickr(".hourpicker-sitc", {
    enableTime: true,
    allowInput: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    locale: document.querySelector("body").dataset.lang,
    onOpen: function (selectedDates, dateStr, instance) {
      if (dateStr === "") {
        instance.setDate("12:00");
      }
    },
  });

  // Social media dynamic fields
  let countSM = 1;
  if (document.querySelectorAll(".js-btn-add-sm").length > 0) {
    let btnAddSm = document.querySelector(".js-btn-add-sm");
    let wrapperSm = document.getElementById("socialMediaWrapper");
    btnAddSm.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let sampleSM = document.querySelector(btnAddSm.dataset.target);
      var clone = sampleSM.cloneNode(true);
      clone.dataset.group = countSM;
      clone.querySelector(".js-remove-sm").dataset.group = countSM;
      clone.querySelector(".js-social-label").id = "socialLabel" + countSM;
      clone.querySelector(".js-social-link").id = "socialLink" + countSM;
      clone.querySelector(".js-social-label").setAttribute("name", "social.social[" + countSM + "].label");
      clone.querySelector(".js-social-link").setAttribute("name", "social.social[" + countSM + "].url");
      clone.querySelector(".js-social-label").value = "";
      clone.querySelector(".js-social-link").value = "";
      clone.querySelector(".js-label-social-label").setAttribute("for", "socialLabel" + countSM);
      clone.querySelector(".js-label-social-link").setAttribute("for", "socialLink" + countSM);
      wrapperSm.appendChild(clone);

      countSM += 1;
    });
  }

  // Prices dynamic fields
  let countPrice = 1;
  if (document.querySelectorAll(".js-btn-add-price").length > 0) {
    let btnAddPrice = document.querySelector(".js-btn-add-price");
    let wrapperPrices = document.getElementById("pricesWrapper");
    btnAddPrice.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let samplePrice = document.querySelector(btnAddPrice.dataset.target);
      var clone = samplePrice.cloneNode(true);
      clone.dataset.group = countPrice;
      clone.querySelector(".js-remove-price").dataset.group = countPrice;
      if (clone.querySelectorAll(".js-title-price").length > 0) {
        clone.querySelector(".js-title-price").id = "priceLabel" + countPrice;
        clone.querySelector(".js-value-price").id = "priceValue" + countPrice;
        clone.querySelector(".js-title-price").setAttribute("name", "opening.pricingData[" + countPrice + "].title");
        clone.querySelector(".js-value-price").setAttribute("name", "opening.pricingData[" + countPrice + "].value");
        clone.querySelector(".js-title-price").value = "";
        clone.querySelector(".js-value-price").value = "";
      } else {
        clone.querySelector(".js-title-price-spotted").id = "priceLabel" + countPrice;
        clone.querySelector(".js-value-price-spotted").id = "priceValue" + countPrice;
        clone.querySelector(".js-title-price-spotted").setAttribute("name", "pricing[" + countPrice + "].labelprice");
        clone.querySelector(".js-value-price-spotted").setAttribute("name", "pricing[" + countPrice + "].price");
        clone.querySelector(".js-title-price-spotted").value = "";
        clone.querySelector(".js-value-price-spotted").value = "";
      }
      clone.querySelector(".js-title-price-label").setAttribute("for", "priceLabel" + countPrice);
      clone.querySelector(".js-value-price-label").setAttribute("for", "priceValue" + countPrice);
      wrapperPrices.appendChild(clone);

      countPrice += 1;
    });
  }

  if (document.querySelectorAll(".js-btn-show-price").length > 0) {
    let btnAddPrice = document.querySelector(".js-btn-show-price");
    let wrapperPrices = document.getElementById("pricesWrapper");
    btnAddPrice.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let samplePrice = document.querySelector(btnAddPrice.dataset.target + ".hidden");
      samplePrice.classList.remove("hidden");

      if (!document.querySelector(btnAddPrice.dataset.target + ".hidden")) {
        btnAddPrice.classList.add("hidden");
      }
    });
  }

  // Timetable dynamic fields
  let countTimetable = 1;
  if (document.querySelectorAll(".js-btn-add-timetable").length > 0) {
    let btnAddTimetable = document.querySelector(".js-btn-add-timetable");
    let wrapperTimetable = document.getElementById("timetableWrapper");
    btnAddTimetable.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let sampleTimetable = document.querySelector(btnAddTimetable.dataset.target);
      var clone = sampleTimetable.cloneNode(true);
      clone.dataset.group = countTimetable;
      clone.querySelector(".js-remove-timetable").dataset.group = countTimetable;
      clone.querySelector(".js-title-timetable").id = "hourLabel" + countTimetable;
      clone.querySelector(".js-value-timetable").id = "hourValue" + countTimetable;
      clone.querySelector(".js-title-timetable").setAttribute("name", "timetable[" + countTimetable + "].day");
      clone.querySelector(".js-value-timetable").setAttribute("name", "timetable[" + countTimetable + "].time");
      clone.querySelector(".js-title-timetable").value = "";
      clone.querySelector(".js-value-timetable").value = "";
      clone.querySelector(".js-title-timetable-label").setAttribute("for", "hourLabel" + countTimetable);
      clone.querySelector(".js-value-timetable-label").setAttribute("for", "hourValue" + countTimetable);
      wrapperTimetable.appendChild(clone);

      countTimetable += 1;
    });
  }

  // Dates dynamic fields
  if (document.querySelectorAll(".js-btn-add-date").length > 0) {
    let countDate = document.querySelectorAll(".js-date-fixed").length;
    let btnAddDate = document.querySelector(".js-btn-add-date");
    let wrapperDates = document.querySelector(".js-dates-fixed-wrapper");
    btnAddDate.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let sampleDate = document.querySelector(btnAddDate.dataset.target);
      var clone = sampleDate.cloneNode(true);
      clone.dataset.group = countDate;
      clone.querySelector(".js-remove-date").dataset.group = countDate;
      clone.querySelector(".js-remove-date").classList.remove("hidden");
      clone.querySelector(".js-date-from").id = "dateFrom" + countDate;
      clone.querySelector(".js-hour-from").id = "hourFrom" + countDate;
      clone.querySelector(".js-hour-to").id = "hourTo" + countDate;
      clone.querySelector(".js-date-from").value = "";
      clone.querySelector(".js-hour-from").value = "";
      clone.querySelector(".js-hour-to").value = "";
      // flatpickr marque ses champs déjà initialisés : sans ce nettoyage le clone
      // n'ouvrirait aucun calendrier.
      clone.querySelectorAll("input._flatpickr, input.flatpickr-input").forEach((input) => {
        input.classList.remove("flatpickr-input", "_flatpickr", "active", "form-control-sitc-error");
        delete input._flatpickr;
      });
      sitcRelabelFixedRow(clone, countDate);
      clone.querySelector(".js-date-from-timezone").dataset.name = "event.dates[" + countDate + "].from";
      clone.querySelector(".js-date-to-timezone").dataset.name = "event.dates[" + countDate + "].to";
      clone.querySelector(".js-date-from-timezone").value = "";
      clone.querySelector(".js-date-to-timezone").value = "";
      clone.querySelectorAll(".js-field-error").forEach((el) => el.remove());
      wrapperDates.appendChild(clone);

      flatpickr(".datepicker-sitc", {
        minDate: "today",
        allowInput: true,
        locale: document.querySelector("body").dataset.lang,
      });

      flatpickr(".hourpicker-sitc", {
        enableTime: true,
        allowInput: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: document.querySelector("body").dataset.lang,
        onOpen: function (selectedDates, dateStr, instance) {
          if (dateStr === "") {
            instance.setDate("12:00");
          }
        },
      });

      countDate += 1;
    });
  }

  let sitcForm = document.getElementById("formPostEvent");
  sitcForm.addEventListener(
    "submit",
    function (event) {
      let form = event.currentTarget;

      // Un prix n'est "actif" que s'il a une valeur.
      let priceInputs = form.querySelectorAll("input.js-value-price");
      for (const priceInput of priceInputs) {
        let activeTarget = document.getElementById(priceInput.dataset.activeTarget);
        if (priceInput.value !== "") {
          activeTarget.value = "true";
        } else {
          activeTarget.value = "";
        }
      }

      const invalid = sitcValidate(form);
      if (invalid.length > 0) {
        event.preventDefault();
        const summary = sitcShowSummary(form);
        summary.scrollIntoView({ behavior: "smooth", block: "center" });
        summary.focus({ preventScroll: true });
        const first = invalid[0];
        if (first && typeof first.focus === "function") {
          window.setTimeout(() => first.focus({ preventScroll: true }), 400);
        }
        return;
      }

      // À partir d'ici seulement : on nomme les champs de dates réellement remplis.
      sitcApplyDateNames(form);

      // Sans image choisie, ne pas envoyer de pièce jointe vide.
      const fileInput = document.getElementById("image");
      if (fileInput && fileInput.files.length === 0) {
        fileInput.disabled = true;
      }
    },
    false,
  );

  // Un champ number se laisse incrémenter à la molette : en défilant la page on
  // modifierait le prix sans le voir. On rend le focus à la page.
  sitcForm.addEventListener(
    "wheel",
    function (e) {
      const field = e.target;
      if (field && field.tagName === "INPUT" && field.type === "number" && field === document.activeElement) {
        field.blur();
      }
    },
    { passive: true },
  );

  document.addEventListener("click", function (e) {
    if (e.target && (e.target.classList.contains("js-remove-sm") || e.target.classList.contains("js-icon-remove-sm"))) {
      e.preventDefault();
      e.stopPropagation();
      let btnDeleteSm = e.target;
      if (e.target.classList.contains("js-icon-remove-sm")) {
        btnDeleteSm = e.target.parentNode;
      }
      if (document.querySelectorAll(".js-social-media-wrapper").length > 1) {
        let elemToDelete = document.querySelector(".js-social-media-wrapper[data-group='" + btnDeleteSm.dataset.group + "']");
        elemToDelete.remove();
        let elementsSm = document.querySelectorAll(".js-social-media-wrapper");
        let index = 0;
        for (const elementSm of elementsSm) {
          elementSm.dataset.group = index;
          elementSm.querySelector(".js-remove-sm").dataset.group = index;
          elementSm.querySelector(".js-social-label").id = "socialLabel" + index;
          elementSm.querySelector(".js-social-link").id = "socialLink" + index;
          elementSm.querySelector(".js-social-label").setAttribute("name", "social.social[" + index + "].label");
          elementSm.querySelector(".js-social-link").setAttribute("name", "social.social[" + index + "].url");
          elementSm.querySelector(".js-label-social-label").setAttribute("for", "socialLabel" + index);
          elementSm.querySelector(".js-label-social-link").setAttribute("for", "socialLink" + index);
          index += 1;
        }
        countSM -= 1;
      }
    } else if (e.target && (e.target.classList.contains("js-remove-price") || e.target.classList.contains("js-icon-remove-price"))) {
      e.preventDefault();
      e.stopPropagation();
      let btnDeletePrice = e.target;
      if (e.target.classList.contains("js-icon-remove-price")) {
        btnDeletePrice = e.target.parentNode;
      }
      if (document.querySelectorAll(".js-price-wrapper").length > 1) {
        let elemToDelete = document.querySelector(".js-price-wrapper[data-group='" + btnDeletePrice.dataset.group + "']");
        elemToDelete.remove();
        let elementsPrice = document.querySelectorAll(".js-price-wrapper");
        let index = 0;
        for (const elementPrice of elementsPrice) {
          elementPrice.dataset.group = index;
          elementPrice.querySelector(".js-remove-price").dataset.group = index;
          if (elementPrice.querySelectorAll(".js-title-price").length > 0) {
            elementPrice.querySelector(".js-title-price").id = "priceLabel" + index;
            elementPrice.querySelector(".js-value-price").id = "priceValue" + index;
            elementPrice.querySelector(".js-title-price").setAttribute("name", "opening.pricingData[" + index + "].title");
            elementPrice.querySelector(".js-value-price").setAttribute("name", "opening.pricingData[" + index + "].value");
          } else {
            elementPrice.querySelector(".js-title-price-spotted").id = "priceLabel" + index;
            elementPrice.querySelector(".js-value-price-spotted").id = "priceValue" + index;
            elementPrice.querySelector(".js-title-price-spotted").setAttribute("name", "pricing[" + index + "].labelprice");
            elementPrice.querySelector(".js-value-price-spotted").setAttribute("name", "pricing[" + index + "].price");
          }
          elementPrice.querySelector(".js-title-price-label").setAttribute("for", "priceLabel" + index);
          elementPrice.querySelector(".js-value-price-label").setAttribute("for", "priceValue" + index);
          index += 1;
        }
        countPrice -= 1;
      }
    } else if (e.target && (e.target.classList.contains("js-hide-price") || e.target.classList.contains("js-icon-hide-price"))) {
      e.preventDefault();
      e.stopPropagation();
      let btnDeletePrice = e.target;
      if (e.target.classList.contains("js-icon-hide-price")) {
        btnDeletePrice = e.target.parentNode;
      }
      let elemToHide = document.querySelector(".js-price-wrapper[data-group='" + btnDeletePrice.dataset.group + "']");
      // clean input values
      elemToHide.querySelectorAll('input[name="opening.pricingDataCustom' + btnDeletePrice.dataset.group + 'Label"]').item(0).value = "";
      elemToHide.querySelectorAll('input[name="opening.pricingDataCustom' + btnDeletePrice.dataset.group + 'Price"]').item(0).value = "";
      // then hide
      elemToHide.classList.add("hidden");

      let btnAddPrice = document.querySelector(".js-btn-show-price");
      if (document.querySelector(btnAddPrice.dataset.target + ".hidden")) {
        btnAddPrice.classList.remove("hidden");
      }
    } else if (e.target && (e.target.classList.contains("js-remove-timetable") || e.target.classList.contains("js-icon-remove-timetable"))) {
      e.preventDefault();
      e.stopPropagation();
      let btnDeleteTimetable = e.target;
      if (e.target.classList.contains("js-icon-remove-timetable")) {
        btnDeleteTimetable = e.target.parentNode;
      }
      if (document.querySelectorAll(".js-timetable-wrapper").length > 1) {
        let elemToDelete = document.querySelector(".js-timetable-wrapper[data-group='" + btnDeleteTimetable.dataset.group + "']");
        elemToDelete.remove();
        let elementsTimatables = document.querySelectorAll(".js-timetable-wrapper");
        let index = 0;
        for (const elementsTimatable of elementsTimatables) {
          elementsTimatable.dataset.group = index;
          elementsTimatable.querySelector(".js-remove-timetable").dataset.group = index;
          elementsTimatable.querySelector(".js-title-timetable").id = "timetableLabel" + index;
          elementsTimatable.querySelector(".js-value-timetable").id = "timetableValue" + index;
          elementsTimatable.querySelector(".js-title-timetable").setAttribute("name", "timetable[" + index + "].day");
          elementsTimatable.querySelector(".js-value-timetable").setAttribute("name", "timetable[" + index + "].time");
          elementsTimatable.querySelector(".js-title-timetable-label").setAttribute("for", "timetableLabel" + index);
          elementsTimatable.querySelector(".js-value-timetable-label").setAttribute("for", "timetableValue" + index);
          index += 1;
        }
        countTimetable -= 1;
      }
    } else if (e.target && (e.target.classList.contains("js-remove-date") || e.target.classList.contains("js-icon-remove-date"))) {
      e.preventDefault();
      e.stopPropagation();
      let btnDeleteDate = e.target.closest(".js-remove-date");
      let rows = document.querySelectorAll(".js-date-fixed");
      if (btnDeleteDate && rows.length > 1) {
        btnDeleteDate.closest(".js-date-fixed").remove();
        let index = 0;
        document.querySelectorAll(".js-date-fixed").forEach((row) => {
          row.dataset.group = index;
          row.querySelector(".js-remove-date").dataset.group = index;
          row.querySelector(".js-date-from").id = "dateFrom" + index;
          row.querySelector(".js-hour-from").id = "hourFrom" + index;
          row.querySelector(".js-hour-to").id = "hourTo" + index;
          sitcRelabelFixedRow(row, index);
          row.querySelector(".js-date-from-timezone").dataset.name = "event.dates[" + index + "].from";
          row.querySelector(".js-date-to-timezone").dataset.name = "event.dates[" + index + "].to";
          index += 1;
        });
      }
    }
  });

  if (document.querySelectorAll(".js-name-event").length > 0) {
    let inputsName = document.querySelectorAll(".js-name-event");
    for (const inputName of inputsName) {
      inputName.addEventListener("change", (e) => {
        document.querySelector(inputName.dataset.target).value = slugify(inputName.value);
      });
    }
  }

  // Dates : un seul écouteur délégué couvre les trois blocs et les lignes clonées.
  sitcForm.addEventListener("change", (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    const fixedRow = target.closest(".js-date-fixed");
    if (fixedRow) {
      sitcSyncFixedRow(fixedRow);
    } else if (target.closest(".js-date-wrapper-period")) {
      sitcSyncPeriod();
    } else if (target.closest(".js-date-wrapper-recurrence")) {
      sitcSyncRecurrence();
    }
  });
  sitcSyncAllDates();
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".form-sitc").length > 0) {
    const wrapper = document.getElementById("fileUploadWrapper");
    const dropZone = document.getElementById("dropZone");
    const fileInput = document.getElementById("image");
    const uploadState = document.getElementById("uploadState");
    const previewState = document.getElementById("previewState");
    const previewImage = document.getElementById("previewImage");
    const fileName = document.getElementById("fileName");
    const fileSize = document.getElementById("fileSize");
    const removeFile = document.getElementById("removeFile");
    const fileError = document.getElementById("fileError");
    const dragOverlay = document.getElementById("dragOverlay");

    const sitcFormEl = document.getElementById("formPostEvent");
    const fileMessages = sitcFormEl ? sitcFormEl.dataset : {};

    // Clic sur la zone ouvre le file picker
    dropZone.addEventListener("click", (e) => {
      if (e.target.closest(".remove-file")) return;
      fileInput.click();
    });

    // La zone de dépôt est le seul point d'entrée visible : elle doit aussi
    // répondre au clavier (l'input file est masqué).
    dropZone.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        fileInput.click();
      }
    });

    // Sélection via file picker
    fileInput.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (file) handleFile(file);
    });

    // Drag & Drop events avec compteur pour éviter le flickering
    let dragCounter = 0;

    ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
      dropZone.addEventListener(eventName, preventDefaults, false);
    });

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Drag enter - incrémente le compteur et montre l'overlay
    dropZone.addEventListener("dragenter", (e) => {
      dragCounter++;
      if (dragCounter === 1) {
        dragOverlay.classList.remove("hidden");
        dropZone.classList.add("drag-over");
      }
    });

    // Drag leave - décrémente le compteur et cache l'overlay seulement quand on sort vraiment
    dropZone.addEventListener("dragleave", (e) => {
      dragCounter--;
      if (dragCounter === 0) {
        dragOverlay.classList.add("hidden");
        dropZone.classList.remove("drag-over");
      }
    });

    // Drop - reset le compteur et cache l'overlay
    dropZone.addEventListener("drop", (e) => {
      dragCounter = 0;
      dragOverlay.classList.add("hidden");
      dropZone.classList.remove("drag-over");

      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith("image/")) {
        fileInput.files = e.dataTransfer.files;
        handleFile(file);
      } else {
        showError(fileMessages.msgFileType);
      }
    });

    function handleFile(file) {
      // Validation taille (5MB max)
      if (file.size > 5 * 1024 * 1024) {
        rejectFile(fileMessages.msgFileSize);
        return;
      }

      // Validation type
      if (!file.type.startsWith("image/")) {
        rejectFile(fileMessages.msgFileType);
        return;
      }

      fileInput.dataset.invalid = "false";
      hideError();

      // Preview
      const reader = new FileReader();
      reader.onload = (e) => {
        previewImage.src = e.target.result;
        dropZone.classList.add("has-file");
      };
      reader.readAsDataURL(file);

      // Info fichier
      fileName.textContent = file.name;
      fileSize.textContent = formatFileSize(file.size);
    }

    function formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    }

    // Supprimer le fichier
    removeFile.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearFile();
      dropZone.focus();
    });

    function clearFile() {
      fileInput.value = "";
      fileInput.dataset.invalid = "false";
      dropZone.classList.remove("has-file");
      previewImage.src = "";
      fileName.textContent = "";
      fileSize.textContent = "";
    }

    // Un fichier refusé doit être retiré de l'input : sinon il partait quand même
    // à l'envoi, malgré le message d'erreur affiché.
    function rejectFile(msg) {
      clearFile();
      fileInput.dataset.invalid = "false";
      showError(msg);
    }

    function showError(msg) {
      fileError.textContent = msg;
      fileError.classList.remove("hidden");
      setTimeout(() => fileError.classList.add("hidden"), 8000);
    }

    function hideError() {
      fileError.classList.add("hidden");
    }
  }
});
